import apiClient from 'api/apiClient';

export const getPortfolioAnalyticsEmbedUrl = ({ embedPath }) => {
  let result = null;
  result = apiClient.get(`/v1/portfolio_analytics/embed/embed_url?embed_path=${embedPath}`);
  return result;
};

export default getPortfolioAnalyticsEmbedUrl;
